exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.rotatoscope-container {\n  position: relative;\n  transform-style: preserve-3d;\n}\n.rotatoscope-content {\n  transform-origin: center;\n  transform-style: preserve-3d;\n}\n.axes {\n  position: absolute;\n  left: 50%;\n  bottom: 50%;\n  width: 100px;\n  height: 100px;\n  transform-style: preserve-3d;\n}\n.axis, .x-axis, .y-axis, .z-axis {\n  transform-style: preserve-3d;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100px;\n  height: 2px;\n  border-radius: 1px;\n  transform-origin: bottom left;\n}\n.x-axis {\n  background-color: red;\n}\n.y-axis {\n  background-color: green;\n  transform: rotateZ(-90deg);\n}\n.z-axis {\n  background-color: blue;\n  transform: rotateY(-90deg);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2dd3afc8","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/rotatoscope.vue
// module id = 25
// module chunks = 0